import { Injectable } from "@angular/core";
import { EmailLogsModel } from "common/models/page-models/email-logs/email-logs-data-model";
import { EmailLogsGridMetaModel } from "common/models/page-models/email-logs/email-logs-grid-meta-model";
import { EmailLogsListingModel } from "common/models/page-models/email-logs/email-logs-grid-model";
import { MetaModel } from "common/models/utility-models/base-model";
import { SystemService } from "common/services/core-services/system.service";
import { GridWidgetService } from "../grid-widget.services";
import { EmailLogDataService } from "common/services/data-services/admin/email-logs/email-logs-data.service";

@Injectable({
  providedIn: "root",
})
export class EmailLogsWidgetService extends GridWidgetService<
  EmailLogsModel,
  EmailLogsListingModel
> {
  constructor(
    protected override ds:EmailLogDataService,
    protected systemService: SystemService
  ) {
    super(ds);
  }

  getMetaModel(): MetaModel {
    const meta = new EmailLogsGridMetaModel().getMetaModel();
    return meta;
  }
}
